// Tasas de cambio actualizadas (Junio 2025)
// Fuente: Banco de la República / XE.com
// Última actualización: 2025-06-15
export const EXCHANGE_RATES = {
  COP_TO_USD: 0.000238,   // 1 COP = 0.000238 USD (~4,200 COP por 1 USD)
  COP_TO_EUR: 0.000211,   // 1 COP = 0.000211 EUR (~4,740 COP por 1 EUR)
  lastUpdated: '2025-06-15',
};

const COP_TO_USD_RATE = EXCHANGE_RATES.COP_TO_USD;
const COP_TO_EUR_RATE = EXCHANGE_RATES.COP_TO_EUR;

export const formatCOP = (price: number) => {
  return new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(price);
};

export const convertToUSD = (copPrice: number) => {
  return copPrice * COP_TO_USD_RATE;
};

export const convertToEUR = (copPrice: number) => {
  return copPrice * COP_TO_EUR_RATE;
};

export const formatUSD = (usdPrice: number) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(usdPrice);
};

export const formatEUR = (eurPrice: number) => {
  return new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(eurPrice);
};

export const formatCOPWithUSD = (copPrice: number) => {
  const cop = formatCOP(copPrice);
  const usd = formatUSD(convertToUSD(copPrice));
  return { cop, usd };
};

// Nueva función para calcular precios USD con descuento
export const formatUSDWithDiscount = (copPrice: number, copOldPrice?: number) => {
  const currentUSD = convertToUSD(copPrice);
  const oldUSD = copOldPrice ? convertToUSD(copOldPrice) : null;
  
  return {
    current: formatUSD(currentUSD),
    old: oldUSD ? formatUSD(oldUSD) : null,
  };
};

/**
 * Devuelve el precio principal y el $479.500 según la moneda seleccionada.
 * currency: 'COP' | 'USD' | 'EUR'
 */
export const getDisplayPrice = (
  copPrice: number,
  copOldPrice?: number,
  currency: 'COP' | 'USD' | 'EUR' = 'COP',
) => {
  if (currency === 'USD') {
    const current = formatUSD(convertToUSD(copPrice));
    const old = copOldPrice ? formatUSD(convertToUSD(copOldPrice)) : undefined;
    return { main: current, oldMain: old, suffix: 'USD' };
  }
  if (currency === 'EUR') {
    const current = formatEUR(convertToEUR(copPrice));
    const old = copOldPrice ? formatEUR(convertToEUR(copOldPrice)) : undefined;
    return { main: current, oldMain: old, suffix: 'EUR' };
  }
  const current = formatCOP(copPrice);
  const old = copOldPrice ? formatCOP(copOldPrice) : undefined;
  return { main: current, oldMain: old, suffix: 'COP' };
};

/**
 * Devuelve la línea secundaria de precio (la moneda alternativa).
 */
export const getSecondaryPrice = (
  copPrice: number,
  copOldPrice?: number,
  currency: 'COP' | 'USD' | 'EUR' = 'COP',
) => {
  if (currency === 'USD') {
    // Secundario es COP
    const current = formatCOP(copPrice);
    const old = copOldPrice ? formatCOP(copOldPrice) : undefined;
    return { current, old, label: 'COP' };
  }
  if (currency === 'EUR') {
    // Secundario es COP
    const current = formatCOP(copPrice);
    const old = copOldPrice ? formatCOP(copOldPrice) : undefined;
    return { current, old, label: 'COP' };
  }
  // Secundario es USD
  const current = formatUSD(convertToUSD(copPrice));
  const old = copOldPrice ? formatUSD(convertToUSD(copOldPrice)) : undefined;
  return { current, old, label: 'USD' };
};
